import { t } from '@lingui/core/macro';
import { IconButton } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { useScreenLayout } from './ScreenLayoutProvider';
export function SidebarSizeToggleButton() {
    const { sidebar } = useScreenLayout();
    const { isExpanded, collapse, expand } = sidebar;
    const toggleTooltip = isExpanded
        ? t({
            comment: 'Sidebar toggle size button tooltip - Collapse sidebar',
            message: 'Collapse sidebar',
        })
        : t({
            comment: 'Sidebar toggle size button tooltip - Expand sidebar',
            message: 'Expand sidebar',
        });
    const toggleExpanded = () => {
        if (isExpanded) {
            collapse();
        }
        else {
            expand();
        }
    };
    return (<IconButton size="small" appearance="ghost" onClick={toggleExpanded} aria-label={toggleTooltip}>
      {isExpanded ? <Falcon icon="compress-wide"/> : <Falcon icon="expand-wide"/>}
    </IconButton>);
}
